import GalaxyFileUploadSourceIcon from "../../assets/components/sources/GalaxyFileUploadSourceIcon";

const GalaxyFileUploadIcon = ({ height }: { height: number }) => {
  return <GalaxyFileUploadSourceIcon height={height} />;
};

export default GalaxyFileUploadIcon;
